export const initialValues = {
    referralType: 'ct',
    importantInformation: '',
    researchInLastMonths: '',
    isPregnat: null,
    personalInformation: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        houseNumber: '',
        city: '',
        zipCode: '',
        pesel: '',
    },
};
